<template>
    <div class="fixed z-40 top-72 right-0 flex">
        <button
            type="button"
            class="h-14 w-14 bg-yellow-100 border border-r-0 rounded-bl-lg md:rounded-tl-lg"
            @click="showModal = !showModal"
        >
            <span class="flex h-full flex-col justify-center items-center">
                <svg v-if="!showModal" width="22" height="22" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </span>
        </button>
        <div v-if="showModal" class="bg-yellow-100 h-64 w-72 rounded-bl-lg p-3">
            <div class="flex justify-between items-center mb-3">
                <h3 class="text-lg">Notes</h3>
                <span v-if="saved" class="flex space-x-1 text-sm text-green-600 items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>Saved</span>
                </span>
                <span v-else class="flex space-x-1 text-sm text-yellow-600 items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                    </svg>
                    <span>Saving</span>
                </span>
            </div>
            <textarea
                class="w-full h-48 bg-yellow-100"
                placeholder="Add a note..."
                v-model="notes"
            />
        </div>
    </div>
</template>

<script setup>
import {onMounted, ref, watch} from 'vue'
import {useProposalOldStore} from "@/Stores/ProposalOld";
import {notify} from "notiwind";

const showModal = ref(false)
const notes = ref('');
const store = useProposalOldStore()
const saved = ref(true)
const saveTimer = ref(null)

onMounted(() => {
    notes.value = store.proposal.notes
})

watch(notes, () => {
    saved.value = false
    clearTimeout(saveTimer.value);
    saveTimer.value = setTimeout(save, 1000);
})

function save() {
    axios.post(route('api.proposal.store', {proposal: store.proposal.id}), {notes: notes.value})
        .then(() => {
            saved.value = true
        }).catch(error => {
        notify({
            type: 'danger',
            title: 'Something went wrong',
            text: 'Could not save notes',
        }, 4000)
        console.log(error)
    }).finally(() => {

    })
}

function onEnd() {
  store.proposal.places.forEach((place, index) => {
    store.proposal.places[index].pivot.order = index
  })
}


</script>
